import { useStaticQuery, graphql } from "gatsby"
import { IGatsbyImageData } from "gatsby-plugin-image"

interface YouTubeThumbnailNode {
  videoId: string
  image: {
    childImageSharp: {
      gatsbyImageData: IGatsbyImageData
    }
  }
}

interface YouTubeThumbnailQueryData {
  allYouTubeThumbnail?: {
    nodes: YouTubeThumbnailNode[]
  }
}

export const useYouTubeThumbnail = (
  videoId: string,
): IGatsbyImageData | null => {
  const data: YouTubeThumbnailQueryData = useStaticQuery(graphql`
    query {
      allYouTubeThumbnail {
        nodes {
          videoId
          image {
            childImageSharp {
              gatsbyImageData(
                width: 480
                height: 360
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
                quality: 90
              )
            }
          }
        }
      }
    }
  `)

  if (!videoId || !data.allYouTubeThumbnail) return null

  const thumbnail = data.allYouTubeThumbnail.nodes.find(
    (node) => node.videoId === videoId,
  )

  return thumbnail?.image?.childImageSharp?.gatsbyImageData || null
}

// Hook to get all YouTube thumbnails (useful for when you need multiple)
export const useAllYouTubeThumbnails = (): Record<string, IGatsbyImageData> => {
  const data: YouTubeThumbnailQueryData = useStaticQuery(graphql`
    query {
      allYouTubeThumbnail {
        nodes {
          videoId
          image {
            childImageSharp {
              gatsbyImageData(
                width: 480
                height: 360
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
                quality: 90
              )
            }
          }
        }
      }
    }
  `)

  if (!data.allYouTubeThumbnail) return {}

  return data.allYouTubeThumbnail.nodes.reduce(
    (acc, node) => {
      acc[node.videoId] = node.image?.childImageSharp?.gatsbyImageData
      return acc
    },
    {} as Record<string, IGatsbyImageData>,
  )
}
